export default "__VITE_ASSET__Bg3y3tGj__"